import { Link } from "react-router-dom";
import { AUTHOR } from "../site";

export default function SiteNav({ mode = "home", currentSection = 0, onSection }) {
  const homeItem = (label, section) => {
    if (mode === "home") {
      return (
        <span
          key={label}
          onClick={() => onSection(section)}
          className={currentSection === section ? "active" : ""}
        >
          {label}
        </span>
      );
    }
    const go = ["", "works", "services", "about"][section];
    return (
      <Link key={label} to={section === 0 ? "/" : `/?go=${go}`}>
        {label}
      </Link>
    );
  };

  return (
    <nav className="navbar">
      <div className="nav-content">
        {mode === "home" ? (
          <div className="logo mono" onClick={() => onSection(0)} style={{ cursor: "pointer" }}>
            jeff<span>.</span>
          </div>
        ) : (
          <Link to="/" className="logo mono">
            jeff<span>.</span>
          </Link>
        )}
        <div className="nav-menu">
          {homeItem("Home", 0)}
          {homeItem("Works", 1)}
          {homeItem("Services", 2)}
          {homeItem("About me", 3)}
          <Link to="/blog" className={mode === "blog" ? "active" : ""}>
            Blog
          </Link>
        </div>
        <a className="btn-blue mono" href={`mailto:${AUTHOR.email}`}>
          LET'S TALK
        </a>
      </div>
    </nav>
  );
}
